<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex v-if="loading == true" lg12>
        <h2 style="padding-top: 10%;"><center>Loading Details<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
      </v-flex>
      <v-flex v-if="loading == false" lg12>
        <small style="display: block;margin-bottom: 20px;" v-if="checkedMessage == true"><strong>Please Note:</strong> You will only be able to advance a status passed "Checked Out" once that status has been reached.</small>
        <label class="blackLabel">Select Updated Status</label>
        <v-select @input="fncShowReasons" class="colorSelect" style="width: 40%" :items="popupStatus" v-model="newStatus" :label="globalModalParams.currentStatus" item-value="text" autocomplete solo></v-select>
        <!--<v-select :items="statusListDropdown" @input="fncCheckStatus()" v-model="globalModalParams.selectedStatus" label="Select Status" item-value="text" autocomplete solo></v-select>-->
        <br /><label class="blackLabel" v-if="newStatus != this.globalModalParams.currentStatus">Please select a reason for status change before proceeding</label>
        <v-select id="reasonSelect" @input="fncChangeReason" v-if="newStatus != this.globalModalParams.currentStatus && reasons.length > 0" class="colorSelectBlack" style="width: 40%" :items="reasons" v-model="reason" item-value="text" label="Select Reason" autocomplete solo></v-select><br />
        <v-text-field id="statusComments" v-show="newStatus != this.globalModalParams.currentStatus && ( reasons.length == 0 || reason == 'Other' )" rows="3" multi-line clearable label="Enter your reason here" v-model="additionalComments" solo></v-text-field>
      </v-flex>
      <div class="pl-4 pr-1 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
          <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
          <v-btn color="success" :disabled="fncCheckIfUpdate()" class="text-xs-right" v-if="!runAdd" @click.stop="fncUpdateQuoteStatus()">Update</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data () {
      return {
        popupStatus: [],
        newStatus: '',
        loading: true,
        isAddValid: true,
        isDiff: false,
        runAdd: false,
        objUser: 0,
        test: '',
        additionalComments: '',
        reasons: [],
        reason: '',
        checkedMessage: false
      };
    },
    methods: {
      fncChangeReason() {
        if( this.reason != 'Other' ) {
          this.additionalComments = this.reason;
        } else {
          this.additionalComments = '';
        }
      },
      fncShowReasons() {
        for( var s in this.globalModalParams.statusList ) {
          if( this.globalModalParams.statusList[s].description == this.newStatus ) {
            this.reasons = [];
            this.reason = '';
            this.additionalComments = '';
            if( this.globalModalParams.statusList[s].reasons && this.globalModalParams.statusList[s].reasons != '' ) {
              var objReasons = this.globalModalParams.statusList[s].reasons.split(',');
              if( objReasons.length > 0 ) {
                // objReasons.push('Other');
                for( var r in objReasons ) {
                  this.reasons.push({id: objReasons[r], text: objReasons[r]});
                }
              }
              setTimeout(function(){
                document.getElementById('reasonSelect').focus();
              }, 1)
            } else {
              setTimeout(function(){
                document.getElementById('statusComments').focus();
              }, 1)
            }
          }
        }
      },
      fncCheckIfUpdate() {
        if( this.newStatus == this.globalModalParams.currentStatus ) {
          return true;
        } else {
          if( this.reasons.length > 0 && this.reason == '' ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncCheckComment(comment) {
        if( comment === '' ) {
          return 'No Comment';
        } else {
          return comment;
        }
      },
      fncUpdateQuoteStatus() {
        this.runAdd = true;
        this.$store.dispatch({
          type: 'fncUpdateQuoteStatus',
          quoteId: this.globalModalParams.quoteId,
          status: this.newStatus,
          prevStatus: this.globalModalParams.currentStatus,
          additionalComments: this.additionalComments
        });
      }/*,
            fncCheckStatus() {
			    console.log( this.globalModalParams.currentStatus + ' - ' + this.globalModalParams.currentStatusStatic );
			    if( this.globalModalParams.currentStatus === this.globalModalParams.currentStatusStatic ) {
                    this.isAddValid = false;
                    this.isDiff = false;
                } else {
                    this.isAddValid = true;
                    this.isDiff = true;
                }
            }*/
    },
      mounted() {
      var mainThis = this;
      setTimeout(function(){

        var checkedOrder = 0;
        var currentOrder = 0;
        for( var s in mainThis.statusList ) {
          if( mainThis.statusList[s].is_checked == 'Yes' || mainThis.statusList[s].is_checked == '1'  ){
            checkedOrder = mainThis.statusList[s].order;
          }
          if( mainThis.globalModalParams.currentStatusStatic == mainThis.statusList[s].description ) {
            currentOrder = mainThis.statusList[s].order;
          }
        }

        if( currentOrder < checkedOrder ) {
          mainThis.checkedMessage = true;
        }

        mainThis.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: mainThis.globalModalParams.quoteId,
          quote: mainThis.globalModalParams.object,
          showPopup: false
        });

        mainThis.loading = false;
        mainThis.newStatus = mainThis.globalModalParams.currentStatus;

        console.log('Status List');
        console.log( mainThis.globalModalParams.statusList );

        if( mainThis.quoteStatuses != null && mainThis.quoteStatuses != '' ) {
          var objQuoteStatuses = mainThis.quoteStatuses.split(',');
        } else {
          var objQuoteStatuses = [];
        }

        for( var s in mainThis.globalModalParams.statusList ) {
          if( mainThis.globalModalParams.quoteTotal == '0' && ( mainThis.globalModalParams.statusList[s].is_checked == 'Yes' || mainThis.globalModalParams.statusList[s].is_hybris == 'Yes')) {
            mainThis.popupStatus.push({ disabled: true, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
          } else if( mainThis.globalModalParams.quoteTotal == '0' && objQuoteStatuses.indexOf( String( mainThis.globalModalParams.statusList[s].id ) ) != -1 ) {
            mainThis.popupStatus.push({ disabled: true, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
          } else {
            mainThis.popupStatus.push({ disabled: mainThis.globalModalParams.statusList[s].disabled, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
            /*if( mainThis.objAuthorize.privileges.indexOf('CAN_UPDATE_BEFORE_AFTER_CHECKOUT') !== -1 ) {
              mainThis.popupStatus.push({ disabled: false, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
            } else {
              if( currentOrder < checkedOrder && mainThis.globalModalParams.statusList[s].order >= checkedOrder ) {
                mainThis.popupStatus.push({ disabled: true, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
              } else if( ( currentOrder == checkedOrder || currentOrder > checkedOrder ) && mainThis.globalModalParams.statusList[s].order <= checkedOrder ) {
                mainThis.popupStatus.push({ disabled: true, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
              } else {
                mainThis.popupStatus.push({ disabled: false, id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description, 'reasons': mainThis.globalModalParams.statusList[s].reasons});
              }
            }*/
          }
        }

      }, 1500)
    },
    beforeMount() {
      this.$store.dispatch('getQuoteSendStatuses', this.objAuthorize.manufacturer);
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'statusListDropdown',
        'quoteStatuses',
        'singleQuoteData',
        'statusList'
      ])
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
